const Themes = {
    Dark: 'Dark',
    Light: 'Light'
};

export default Themes;
